import React from 'react';

class DashboardErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Dashboard rendering error:', error, errorInfo);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.resetKey !== this.props.resetKey && this.state.hasError) {
      this.setState({ hasError: false });
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="dashboard-error">
          <strong>{this.props.title || 'Dashboard view failed to load.'}</strong>
          <div>{this.props.message || 'Try changing the location, manager, or time period to reload the scorecard.'}</div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default DashboardErrorBoundary;
